/**
 * Update Cart Quantity Action
 * Triggered by: arc:action:updateCartQuantity
 */

export const runUpdateCartQuantity = async (data = {}) => {
    try {
        const { variantKey, quantity } = data;
        
        if (!variantKey) {
            throw new Error('Variant key is required');
        }

        if (quantity < 0) {
            throw new Error('Quantity must be positive');
        }

        // Trigger haptic feedback
        if ('vibrate' in navigator) {
            navigator.vibrate(30);
        }

        // Dispatch loading start event
        window.dispatchEvent(new CustomEvent('cart:update_loading_start', { detail: { variantKey, quantity } }));

        // Use Alpine cart store
        await Alpine.store('cart').updateQuantity(variantKey, quantity);

        // Dispatch success event
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { variantKey, quantity } }));
        window.dispatchEvent(new CustomEvent('cart:update_loading_end'));

        return {
            success: true,
            message: 'Quantity updated successfully'
        };

    } catch (error) {
        console.error('Update cart quantity error:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default runUpdateCartQuantity;
